export default "__VITE_ASSET__By73C6Tj__"